// Philosophy.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { TypeAnimation } from "react-type-animation";
import Breadcrumb from "../components/Breadcrumb";
import "./Pages.css";
import "./Philosophy.css";

const Philosophy = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <Breadcrumb />

      <section className="philosophy-page-wrapper">
        <div className="philosophy-container">
          <div className="philosophy-two-columns">
            {/* LEFT COLUMN */}
            <div className="philosophy-content-left" data-aos="fade-right">
              <span className="philosophy-eyebrow">Our Philosophy</span>

              <h1 className="philosophy-main-heading">
                Nothing falls apart faster than an{" "}
                <span className="philosophy-highlight">
                  <TypeAnimation
                    sequence={["unowned plan."]}
                    speed={250}
                    cursor={false}
                  />
                </span>
              </h1>

              <div className="philosophy-text-content">
                <p>
                  Investment strategies rarely fail on paper. They fail in the
                  months after closing, in moments of transition, or under the
                  weight of growth and scrutiny.
                </p>

                <p>Morphis exists in that gap.</p>

                <p>
                  We do not advise from a distance. We embed with teams, lead
                  workstreams, and push decisions through. We bring structure
                  where there is drift, pace where there is hesitation, and
                  judgement where complexity obscures action.
                </p>

                <p>
                  Our mandate is simple: ensure that what was underwritten is
                  what actually gets built.
                </p>
              </div>
            </div>

            {/* RIGHT COLUMN - Full height image */}
            <div className="philosophy-image-right" data-aos="fade-left">
              <img
                src="/assets/img/morphis-philosophy.png"
                alt="Embedded team collaboration"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Philosophy;